import * as tslib_1 from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getTermList, copyTerm, changeStatus } from '@/api/course';
import { mixin_export } from '@/utils/exportFile';
let Login = class Login extends Vue {
    constructor() {
        super(...arguments);
        this.search = {
            campId: '',
            searchContent: '',
            status: '',
            courseOpenStatus: ''
        };
        this.tableData = [];
        this.pageNo = 1;
        this.pageSize = 15;
        this.total = 0;
    }
    created() {
        if (this.$route.query.id) {
            this.search.campId = this.$route.query.id;
        }
        this.getList();
    }
    onSearch() {
        this.pageNo = 1;
        this.getList();
    }
    async getList() {
        let data = {
            pageNo: this.pageNo,
            pageSize: this.pageSize,
            campId: this.search.campId,
            searchContent: this.search.searchContent,
            courseOpenStatus: this.search.courseOpenStatus,
            status: this.search.status,
        };
        const res = await getTermList(data);
        if (res.data.status !== 200)
            return this.$message.error(res.data.msg);
        this.tableData = res.data.data.list;
        this.pageNo = Number(res.data.data.pageNum);
        this.total = Number(res.data.data.total);
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getList();
    }
    changePageSize(pageSize) {
        this.pageSize = pageSize;
        this.getList();
    }
    onAdd(props) {
        let data = {
            campId: this.search.campId
        };
        if (props)
            data.id = props.id;
        this.$router.push({ path: '/course-manager/termAdd', query: data });
    }
    onJump(props) {
        this.$router.push({ path: '/course-manager/studentList', query: {
                id: props.id
            } });
    }
    onExport() {
        this.$confirm('是否确认导出？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            let data = {
                campId: this.search.campId,
                searchContent: this.search.searchContent,
                courseOpenStatus: this.search.courseOpenStatus,
                status: this.search.status,
            };
            mixin_export('/courseAdmin/course/exportTerm', 'get', data);
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
    onChangeStatus(props) {
        this.$confirm(`是否${props.status == 1 ? '停用' : '启用'}？`, "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(async () => {
            let data = {
                id: props.id,
                status: props.status == 1 ? 2 : 1
            };
            const res = await changeStatus(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.$message({
                type: 'success',
                message: '修改成功'
            });
            this.getList();
        });
    }
    onCopy(props) {
        this.$confirm('是否确认复制该营期？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(async () => {
            let data = {
                id: props.id
            };
            const res = await copyTerm(data);
            if (res.data.status !== 200)
                return this.$message.error(res.data.msg);
            this.$message({
                type: 'success',
                message: '复制成功'
            });
            this.getList();
        }).catch(() => {
            this.$message({
                type: 'info',
                message: '已取消'
            });
        });
    }
};
Login = tslib_1.__decorate([
    Component
], Login);
export default Login;
